import { Editor } from '@tiptap/react'
import getFeatureEditor from '@chegg-wt/core-wa/utils/getEditor'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  EDITOR_EVENTS_PLUGIN_KEY,
  editorEvents,
} from '@chegg-wt/core-wa/utils/tipTapExtensions/editorEvents'

const useParaphraserEditor = ({ disabled = false }): Editor | null => {
  const editor = getFeatureEditor()
  const dispatch = useDispatch()

  useEffect(() => {
    editor?.setEditable(!disabled)
    if (!disabled) {
      editor?.commands.focus('end', { scrollIntoView: false })
    }
  }, [disabled, editor])

  useEffect(() => {
    editor?.registerPlugin(editorEvents(dispatch, disabled))

    return () => {
      editor?.unregisterPlugin(EDITOR_EVENTS_PLUGIN_KEY)
    }
  }, [editor, disabled])

  return editor
}

export default useParaphraserEditor
